import max from 'lodash/max';
import min from 'lodash/min';
import zip from 'lodash/zip';
import { AABB } from '../lib/AABB';
import { V2, addV2, newV2 } from '../lib/V2';
import { Facet } from './Facet';

export enum ColliderType {
  Box = 'Box',
  Circle = 'Circle',
  Polygon = 'Polygon',
}

interface ColliderBase<T extends ColliderType> {
  type: T,
  offset: V2,
  trigger?: boolean,
  layer?: number,
}

interface BoxCollider extends ColliderBase<ColliderType.Box> {
  size: V2,
}

interface CircleCollider extends ColliderBase<ColliderType.Circle> {
  radius: number,
}

interface PolygonCollider extends ColliderBase<ColliderType.Polygon> {
  points: V2[],
}

type Collider =
  | BoxCollider
  | CircleCollider
  | PolygonCollider
;

const getColliderAABB = (collider: Collider): AABB => {
  switch (collider.type) {
    case ColliderType.Box: return {
      position: collider.offset,
      size: collider.size,
    };
    case ColliderType.Circle: return {
      position: collider.offset,
      size: [collider.radius * 2, collider.radius * 2],
    };
    case ColliderType.Polygon: {
      const [x, y] = zip(...collider.points);
      return {
        position: addV2([...collider.offset], newV2(min(x), min(y))),
        size: [
          (max(x) || 0) - (min(x) || 0),
          (max(y) || 0) - (min(y) || 0),
        ],
      };
    }
  }
};

export class ColliderFacet extends Facet<Collider> {

  aabb: AABB = { position: newV2(), size: newV2() };

  collisions: Facet<Collider>[] = [];

  start() {
    // HACK: AABB only calculated at start, assumes collider won't change
    this.aabb = getColliderAABB(this.props);
  }
}
